import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const computeCapacityApi = createApi({
  reducerPath: 'computeCapacityApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().user.token;
      if (token) {
        headers.set('authorization', token);
      }
      return headers;
    },
  }),
  tagTypes: ['ComputeCapacity'],
  endpoints: (builder) => ({
    getComputeCapacityList: builder.query({
      query: ({ limit = 10, offset = 0, search = '' }) => ({
        url: `/v1.0/external/capacity/list`,
        params: { limit, offset, search },
      }),
      providesTags: ['ComputeCapacity'],
    }),
    getComputeCapacity: builder.query({
      query: (id) => `/v1.0/external/capacity/${id}`,
      transformResponse: (response) => response.data,
      providesTags: ['ComputeCapacity'],
    }),
    createComputeCapacity: builder.mutation({
      query: (data) => ({
        url: '/v1.0/external/capacity/create',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['ComputeCapacity'],
    }),
    updateComputeCapacity: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/v1.0/external/capacity/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['ComputeCapacity'],
    }),
    deleteComputeCapacity: builder.mutation({
      query: (id) => ({
        url: `/v1.0/external/capacity/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ComputeCapacity'],
    }),
  }),
});

export const {
  useGetComputeCapacityListQuery,
  useGetComputeCapacityQuery,
  useCreateComputeCapacityMutation,
  useUpdateComputeCapacityMutation,
  useDeleteComputeCapacityMutation,
} = computeCapacityApi; 